// src/components/dashboard/CoverCard.jsx
//
// Card component for displaying cover submissions in reviewer dashboard.
//
// Props:
// - coverId: draft ID
// - title: book title
// - authorName: author's name
// - coverUrl: URL to cover image
// - onClick: callback when card is clicked (for opening modal)

import React from 'react';
import '../../styles/CoverCard.css';

const CoverCard = ({ coverId, title, authorName, coverUrl, onClick }) => {
  return (
    <article className="cover-card" onClick={onClick}>
      <div className="cover-card-image">
        <img 
          src={coverUrl} 
          alt={`Cover for ${title}`}
        />
      </div>
      <div className="cover-card-body">
        <h4 className="cover-card-title" title={title}>
          {title}
        </h4>
        <p className="cover-card-author">
          by {authorName}
        </p>
      </div>
    </article>
  );
};

export default CoverCard;
